import { createServerFn } from "@tanstack/react-start";
import { readCommunityPage } from "./community.server";
import { siteContext } from "./site.server";

/**
 * Community (/community) in one request: the page the creator composed for it, with the feed at
 * its built-in block, or the native community page.
 */
export const loadCommunity = createServerFn({ method: "GET" }).handler(async ({ context }) => {
  const drate = await siteContext(context);
  return readCommunityPage(drate);
});
